import { render, staticRenderFns } from "./examinationPoints.vue?vue&type=template&id=652251bc&scoped=true"
import script from "./examinationPoints.vue?vue&type=script&lang=js"
export * from "./examinationPoints.vue?vue&type=script&lang=js"
import style0 from "./examinationPoints.vue?vue&type=style&index=0&id=652251bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652251bc",
  null
  
)

export default component.exports